var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "AppBreadCrumb",
        {
          attrs: {
            paths: [{ title: _vm.$t("adminPanel.clusterDashboardTitle") }],
            select: true,
          },
        },
        [
          _c(
            "a-button",
            {
              staticClass: "actionButtonBreadcrumb",
              staticStyle: { "margin-right": "8px" },
              attrs: { disabled: _vm.cleaning },
              on: { click: _vm.clean },
            },
            [
              _vm.cleaning ? _c("a-spin") : _c("md-icon", [_vm._v("refresh")]),
              _vm._v(
                "\n            " +
                  _vm._s(_vm.$t("message.clean")) +
                  "\n        "
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "a-button",
            {
              staticClass: "actionButtonBreadcrumb",
              staticStyle: { "margin-right": "8px" },
              on: { click: _vm.switchToV2 },
            },
            [
              _c("span", { staticClass: "material-icons" }, [
                _vm._v(" fingerprint "),
              ]),
              _vm._v(
                "\n            " +
                  _vm._s(_vm.$t("adminPanel.clusterSwitchV2")) +
                  "\n        "
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "a-button",
            {
              staticClass: "actionButtonBreadcrumb",
              staticStyle: { "margin-right": "8px" },
              on: { click: _vm.refreshCustomerPage },
            },
            [
              _c(
                "span",
                {
                  staticClass: "material-icons",
                  staticStyle: { "font-size": "12px", "margin-right": "5px" },
                },
                [_vm._v(" system_update_alt ")]
              ),
              _vm._v(
                "\n            " +
                  _vm._s(_vm.$t("adminPanel.clusterNewVersion")) +
                  "\n        "
              ),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-container",
        { attrs: { fluid: "" } },
        [
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-3" },
              [
                _c("ECharts", {
                  ref: "chart",
                  staticStyle: { height: "400px", width: "400px" },
                  attrs: { id: "chart-2", option: _vm.tabletCpuGauge },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-6" },
              [
                _c("ECharts", {
                  ref: "chart",
                  attrs: { id: "chart-1", option: _vm.socketCpuGauge },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-3" },
              [
                _c("ECharts", {
                  ref: "chart",
                  staticStyle: { height: "400px", width: "400px" },
                  attrs: { id: "chart-4", option: _vm.masterCpuGauge },
                }),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { id: "chart" } },
            [
              _c(
                "a-button",
                {
                  staticStyle: { "background-color": "lightsteelblue" },
                  on: { click: _vm.toggleDetail },
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm.isVisiblePieChart == false
                        ? _vm.$t("message.showDetail")
                        : _vm.$t("message.hideDetail")
                    ) + "\n            "
                  ),
                ]
              ),
              _vm._v(" "),
              _c("ECharts", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isVisiblePieChart,
                    expression: "isVisiblePieChart",
                  },
                ],
                ref: "chart",
                staticStyle: { height: "calc(100vh - 200px)" },
                attrs: { id: "chart-2", option: _vm.pie },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              {
                staticClass: "col-12",
                staticStyle: {
                  display: "flex",
                  "justify-content": "flex-end",
                  "align-items": "center",
                },
              },
              [
                _c(
                  "b-button",
                  {
                    directives: [
                      {
                        name: "b-modal",
                        rawName: "v-b-modal.logModal",
                        modifiers: { logModal: true },
                      },
                    ],
                    attrs: { type: "submit", variant: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.showLog("tablet")
                      },
                    },
                  },
                  [[_vm._v(" Tablet Logs")]],
                  2
                ),
                _vm._v(" "),
                _c(
                  "b-button",
                  {
                    directives: [
                      {
                        name: "b-modal",
                        rawName: "v-b-modal.logModal",
                        modifiers: { logModal: true },
                      },
                    ],
                    staticClass: "ml-2",
                    attrs: { type: "submit", variant: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.showLog("master")
                      },
                    },
                  },
                  [[_vm._v(" Master Logs")]],
                  2
                ),
                _vm._v(" "),
                _c(
                  "b-button",
                  {
                    directives: [
                      {
                        name: "b-modal",
                        rawName: "v-b-modal.logModal",
                        modifiers: { logModal: true },
                      },
                    ],
                    staticClass: "ml-2",
                    attrs: { type: "submit", variant: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.showLog("socket")
                      },
                    },
                  },
                  [[_vm._v(" Socket Logs")]],
                  2
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-12" },
              [
                _c(
                  "b-form",
                  {
                    staticClass: "d-flex flex-column justify-content-center",
                    on: {
                      submit: function ($event) {
                        $event.preventDefault()
                        return _vm.startLoadTest.apply(null, arguments)
                      },
                    },
                  },
                  [
                    _c(
                      "b-row",
                      [
                        _c(
                          "b-col",
                          { attrs: { md: "2" } },
                          [
                            _c(
                              "md-field",
                              {
                                directives: [
                                  {
                                    name: "tippy",
                                    rawName: "v-tippy",
                                    value: {
                                      followCursor: true,
                                      placement: "bottom-end",
                                      theme: _vm.isDarkMode
                                        ? "light-border"
                                        : "google",
                                    },
                                    expression:
                                      "{\n                                    followCursor: true,\n                                    placement: 'bottom-end',\n                                    theme: isDarkMode ? 'light-border' : 'google',\n                                }",
                                  },
                                ],
                                class: {
                                  "md-invalid":
                                    _vm.errors.first(
                                      _vm.$t("message.target")
                                    ) != null,
                                },
                                attrs: {
                                  content:
                                    "Alabileceği değerler:  development|stage|production",
                                  disabled: "",
                                },
                              },
                              [
                                _c("label", [
                                  _vm._v(_vm._s(_vm.$t("message.target"))),
                                ]),
                                _vm._v(" "),
                                _c("md-input", {
                                  directives: [
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: "required",
                                      expression: "'required'",
                                    },
                                  ],
                                  attrs: { name: _vm.$t("message.target") },
                                  model: {
                                    value: _vm.loadTest.target,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.loadTest, "target", $$v)
                                    },
                                    expression: "loadTest.target",
                                  },
                                }),
                                _vm._v(" "),
                                _c("span", { staticClass: "md-error" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.errors.first(_vm.$t("message.target"))
                                    )
                                  ),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          { attrs: { md: "2" } },
                          [
                            _c(
                              "md-field",
                              {
                                directives: [
                                  {
                                    name: "tippy",
                                    rawName: "v-tippy",
                                    value: {
                                      followCursor: true,
                                      placement: "bottom-end",
                                      theme: _vm.isDarkMode
                                        ? "light-border"
                                        : "google",
                                    },
                                    expression:
                                      "{\n                                    followCursor: true,\n                                    placement: 'bottom-end',\n                                    theme: isDarkMode ? 'light-border' : 'google',\n                                }",
                                  },
                                ],
                                class: {
                                  "md-invalid":
                                    _vm.errors.first(
                                      _vm.$t("message.duration")
                                    ) != null,
                                },
                                attrs: {
                                  content:
                                    "Yük testi kaç saniye sürecekse buraya giriyoruz",
                                },
                              },
                              [
                                _c("label", [
                                  _vm._v(_vm._s(_vm.$t("message.duration"))),
                                ]),
                                _vm._v(" "),
                                _c("md-input", {
                                  directives: [
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: "required",
                                      expression: "'required'",
                                    },
                                  ],
                                  attrs: { name: _vm.$t("message.duration") },
                                  model: {
                                    value: _vm.loadTest.duration,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.loadTest, "duration", $$v)
                                    },
                                    expression: "loadTest.duration",
                                  },
                                }),
                                _vm._v(" "),
                                _c("span", { staticClass: "md-error" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.errors.first(
                                        _vm.$t("message.duration")
                                      )
                                    )
                                  ),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          { attrs: { md: "2" } },
                          [
                            _c(
                              "md-field",
                              {
                                directives: [
                                  {
                                    name: "tippy",
                                    rawName: "v-tippy",
                                    value: {
                                      followCursor: true,
                                      placement: "bottom-end",
                                      theme: _vm.isDarkMode
                                        ? "light-border"
                                        : "google",
                                    },
                                    expression:
                                      "{\n                                    followCursor: true,\n                                    placement: 'bottom-end',\n                                    theme: isDarkMode ? 'light-border' : 'google',\n                                }",
                                  },
                                ],
                                class: {
                                  "md-invalid":
                                    _vm.errors.first(
                                      _vm.$t("message.arrivalCount")
                                    ) != null,
                                },
                                attrs: {
                                  content:
                                    "Yük testi boyunca toplam kaç bot girmesinizi istiyorsanız adetini yazınız",
                                },
                              },
                              [
                                _c("label", [
                                  _vm._v(
                                    _vm._s(_vm.$t("message.arrivalCount"))
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("md-input", {
                                  directives: [
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: "required",
                                      expression: "'required'",
                                    },
                                  ],
                                  attrs: {
                                    name: _vm.$t("message.arrivalCount"),
                                  },
                                  model: {
                                    value: _vm.loadTest.arrivalCount,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.loadTest,
                                        "arrivalCount",
                                        $$v
                                      )
                                    },
                                    expression: "loadTest.arrivalCount",
                                  },
                                }),
                                _vm._v(" "),
                                _c("span", { staticClass: "md-error" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.errors.first(
                                        _vm.$t("message.arrivalCount")
                                      )
                                    )
                                  ),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          { attrs: { md: "2" } },
                          [
                            _c(
                              "md-field",
                              {
                                directives: [
                                  {
                                    name: "tippy",
                                    rawName: "v-tippy",
                                    value: {
                                      followCursor: true,
                                      placement: "bottom-end",
                                      theme: _vm.isDarkMode
                                        ? "light-border"
                                        : "google",
                                    },
                                    expression:
                                      "{\n                                    followCursor: true,\n                                    placement: 'bottom-end',\n                                    theme: isDarkMode ? 'light-border' : 'google',\n                                }",
                                  },
                                ],
                                class: {
                                  "md-invalid":
                                    _vm.errors.first(
                                      _vm.$t("message.bootMaxLife")
                                    ) != null,
                                },
                                attrs: {
                                  content:
                                    "Sisteme giren bir bot kaç saniye boyunca ayakta kalmasını istiyorsanız onu yazın. 10 ve 10'un katları olsun",
                                },
                              },
                              [
                                _c("label", [
                                  _vm._v(_vm._s(_vm.$t("message.bootMaxLife"))),
                                ]),
                                _vm._v(" "),
                                _c("md-input", {
                                  directives: [
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: "required",
                                      expression: "'required'",
                                    },
                                  ],
                                  attrs: {
                                    name: _vm.$t("message.bootMaxLife"),
                                  },
                                  model: {
                                    value: _vm.loadTest.bootMaxLife,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.loadTest, "bootMaxLife", $$v)
                                    },
                                    expression: "loadTest.bootMaxLife",
                                  },
                                }),
                                _vm._v(" "),
                                _c("span", { staticClass: "md-error" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.errors.first(
                                        _vm.$t("message.bootMaxLife")
                                      )
                                    )
                                  ),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          {
                            staticStyle: {
                              display: "flex",
                              "justify-content": "start",
                              "align-items": "center",
                            },
                            attrs: { md: "4" },
                          },
                          [
                            _c(
                              "b-button",
                              {
                                staticClass: "w-100",
                                attrs: { type: "submit", variant: "primary" },
                              },
                              [
                                [
                                  _vm._v(
                                    "\n                                    " +
                                      _vm._s(_vm.$t("message.startLoadTest")) +
                                      "\n                                "
                                  ),
                                ],
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c(
                              "b-button",
                              {
                                staticClass: "ml-2 w-100",
                                attrs: { type: "button", variant: "warning" },
                                on: { click: _vm.stopLoadTest },
                              },
                              [
                                [
                                  _vm._v(
                                    "\n                                    " +
                                      _vm._s(_vm.$t("message.stopLoadTest")) +
                                      "\n                                "
                                  ),
                                ],
                              ],
                              2
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-12" },
              [
                _c("a-table", {
                  key: "vtable-" + _vm.renderCount,
                  staticClass: "custom-table2",
                  attrs: {
                    columns: _vm.cols(),
                    dataSource: _vm.getRows(),
                    locale: {
                      emptyText: _vm.$t("message.noClusterInstanceFound"),
                    },
                    pagination: false,
                    rowKey: "_id",
                  },
                  on: { change: _vm.tableChange },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "idSlot",
                        fn: function (data, item) {
                          return _c(
                            "div",
                            { key: "idSlot" + _vm.$i18n.locale },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    _vm.$_.takeRight(item.instanceId, 3).join(
                                      ""
                                    )
                                  ) +
                                  "\n                    "
                              ),
                            ]
                          )
                        },
                      },
                      {
                        key: "socketCountSlot",
                        fn: function (data, item) {
                          return _c(
                            "div",
                            { key: "socketCountSlot" + _vm.$i18n.locale },
                            [
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "tippy",
                                      rawName: "v-tippy",
                                      value: {
                                        followCursor: true,
                                        placement: "bottom-end",
                                        theme: _vm.isDarkMode
                                          ? "light-border"
                                          : "google",
                                      },
                                      expression:
                                        "{\n                                followCursor: true,\n                                placement: 'bottom-end',\n                                theme: isDarkMode ? 'light-border' : 'google',\n                            }",
                                    },
                                  ],
                                  attrs: {
                                    content:
                                      _vm.siteSocketCountWithSiteNameToolTipDesc(),
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(item.socketCount) +
                                      "\n                        "
                                  ),
                                ]
                              ),
                            ]
                          )
                        },
                      },
                      {
                        key: "masterSlot",
                        fn: function (data, item) {
                          return _c(
                            "div",
                            {},
                            [
                              item.leader
                                ? _c(
                                    "md-icon",
                                    {
                                      directives: [
                                        {
                                          name: "tippy",
                                          rawName: "v-tippy",
                                          value: {
                                            followCursor: true,
                                            placement: "bottom-end",
                                            theme: _vm.isDarkMode
                                              ? "light-border"
                                              : "google",
                                          },
                                          expression:
                                            "{\n                                followCursor: true,\n                                placement: 'bottom-end',\n                                theme: isDarkMode ? 'light-border' : 'google',\n                            }",
                                        },
                                      ],
                                      staticStyle: { color: "green" },
                                      attrs: {
                                        content:
                                          "Bu sunucu bağlı olduğu cluster'da lider konumdadır.",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "coronavirus\n                        "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            1
                          )
                        },
                      },
                      {
                        key: "readySlot",
                        fn: function (data, item) {
                          return _c(
                            "div",
                            { key: "readySlot" + _vm.$i18n.locale },
                            [
                              item.ready
                                ? _c(
                                    "md-icon",
                                    {
                                      directives: [
                                        {
                                          name: "tippy",
                                          rawName: "v-tippy",
                                          value: {
                                            followCursor: true,
                                            placement: "bottom-end",
                                            theme: _vm.isDarkMode
                                              ? "light-border"
                                              : "google",
                                          },
                                          expression:
                                            "{\n                                followCursor: true,\n                                placement: 'bottom-end',\n                                theme: isDarkMode ? 'light-border' : 'google',\n                            }",
                                        },
                                      ],
                                      staticStyle: { color: "green" },
                                      attrs: {
                                        content:
                                          "Bu sunucu cluster'a bağlanmış hazır durumdadır.",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "done_all\n                        "
                                      ),
                                    ]
                                  )
                                : _c(
                                    "md-icon",
                                    {
                                      directives: [
                                        {
                                          name: "tippy",
                                          rawName: "v-tippy",
                                          value: {
                                            followCursor: true,
                                            placement: "bottom-end",
                                            theme: _vm.isDarkMode
                                              ? "light-border"
                                              : "google",
                                          },
                                          expression:
                                            "{\n                                followCursor: true,\n                                placement: 'bottom-end',\n                                theme: isDarkMode ? 'light-border' : 'google',\n                            }",
                                        },
                                      ],
                                      staticStyle: { color: "red" },
                                      attrs: {
                                        content:
                                          "Bu sunucu henüz cluster'a bağlanamamış hazır değildir.",
                                      },
                                    },
                                    [_vm._v("done\n                        ")]
                                  ),
                            ],
                            1
                          )
                        },
                      },
                      {
                        key: "circuitBreakerSlot",
                        fn: function (data, item) {
                          return _c(
                            "div",
                            { key: "circuitBreakerSlot" + _vm.$i18n.locale },
                            [
                              _c(
                                "md-icon",
                                {
                                  directives: [
                                    {
                                      name: "tippy",
                                      rawName: "v-tippy",
                                      value: {
                                        followCursor: true,
                                        placement: "bottom-end",
                                        theme: _vm.isDarkMode
                                          ? "light-border"
                                          : "google",
                                      },
                                      expression:
                                        "{\n                                followCursor: true,\n                                placement: 'bottom-end',\n                                theme: isDarkMode ? 'light-border' : 'google',\n                            }",
                                    },
                                  ],
                                  style: {
                                    color:
                                      item.circuitBreaker &&
                                      item.microService === "socket"
                                        ? "red"
                                        : "green",
                                  },
                                  attrs: {
                                    content:
                                      item.circuitBreaker &&
                                      item.microService === "socket"
                                        ? "Bu sunucu devre kırıcı aktiftir. Trafiğe kapalıdır"
                                        : "Bu sunucuda devre kırıcı kapalıdır. Trafik serbesttir.",
                                  },
                                },
                                [_vm._v("traffic\n                        ")]
                              ),
                            ],
                            1
                          )
                        },
                      },
                      {
                        key: "cpuSlot",
                        fn: function (data, item) {
                          return _c(
                            "div",
                            { key: "cpuSlot" + _vm.$i18n.locale },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    parseFloat((item.cpu.load * 100).toFixed(2))
                                      .toString()
                                      .concat("%")
                                  ) +
                                  "\n                    "
                              ),
                            ]
                          )
                        },
                      },
                      {
                        key: "uptimeSlot",
                        fn: function (data, item) {
                          return _c(
                            "div",
                            { key: "uptime" + _vm.$i18n.locale },
                            [
                              _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "tippy",
                                      rawName: "v-tippy",
                                      value: {
                                        followCursor: true,
                                        placement: "bottom-end",
                                        theme: _vm.isDarkMode
                                          ? "light-border"
                                          : "google",
                                      },
                                      expression:
                                        "{\n                                followCursor: true,\n                                placement: 'bottom-end',\n                                theme: isDarkMode ? 'light-border' : 'google',\n                            }",
                                    },
                                  ],
                                  attrs: {
                                    content:
                                      "Bu sunucunun yaşam süresi: " +
                                      _vm.$moment
                                        .duration(item.uptime, "seconds")
                                        .locale("tr")
                                        .humanize(),
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(item.uptime) +
                                      "\n                        "
                                  ),
                                ]
                              ),
                            ]
                          )
                        },
                      },
                      {
                        key: "actionsSlot",
                        fn: function (data, item) {
                          return _c(
                            "div",
                            { key: "actionsSlot" + _vm.$i18n.locale },
                            [
                              _c(
                                "div",
                                { staticClass: "d-flex w-100" },
                                [
                                  _c(
                                    "md-button",
                                    {
                                      directives: [
                                        {
                                          name: "tippy",
                                          rawName: "v-tippy",
                                          value: {
                                            followCursor: true,
                                            placement: "bottom-end",
                                            theme: _vm.isDarkMode
                                              ? "light-border"
                                              : "google",
                                          },
                                          expression:
                                            "{\n                                    followCursor: true,\n                                    placement: 'bottom-end',\n                                    theme: isDarkMode ? 'light-border' : 'google',\n                                }",
                                        },
                                      ],
                                      staticClass: "md-icon-button",
                                      attrs: {
                                        content: "Stress Testini Başlat",
                                      },
                                      on: {
                                        click: function () {
                                          return _vm.startStressTest(item)
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "md-icon",
                                        { staticStyle: { color: "red" } },
                                        [_vm._v("local_fire_department")]
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "md-button",
                                    {
                                      staticClass: "md-icon-button",
                                      on: {
                                        click: function () {
                                          return _vm.killStressTest(item)
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "md-icon",
                                        {
                                          directives: [
                                            {
                                              name: "tippy",
                                              rawName: "v-tippy",
                                              value: {
                                                followCursor: true,
                                                placement: "bottom-end",
                                                theme: _vm.isDarkMode
                                                  ? "light-border"
                                                  : "google",
                                              },
                                              expression:
                                                "{\n                                        followCursor: true,\n                                        placement: 'bottom-end',\n                                        theme: isDarkMode ? 'light-border' : 'google',\n                                    }",
                                            },
                                          ],
                                          staticStyle: { color: "green" },
                                          attrs: {
                                            content: "Stress Testini Bitir",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "ac_unit\n                                "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "md-button",
                                    {
                                      directives: [
                                        {
                                          name: "tippy",
                                          rawName: "v-tippy",
                                          value: {
                                            followCursor: true,
                                            placement: "bottom-end",
                                            theme: _vm.isDarkMode
                                              ? "light-border"
                                              : "google",
                                          },
                                          expression:
                                            "{\n                                    followCursor: true,\n                                    placement: 'bottom-end',\n                                    theme: isDarkMode ? 'light-border' : 'google',\n                                }",
                                        },
                                      ],
                                      staticClass: "md-icon-button",
                                      attrs: {
                                        content: "Kaynak İzleme Ekranı",
                                      },
                                      on: {
                                        click: function () {
                                          return _vm.monitor(item)
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "md-icon",
                                        { staticStyle: { color: "teal" } },
                                        [_vm._v("memory")]
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "md-button",
                                    {
                                      directives: [
                                        {
                                          name: "b-modal",
                                          rawName: "v-b-modal.connectModal",
                                          modifiers: { connectModal: true },
                                        },
                                        {
                                          name: "tippy",
                                          rawName: "v-tippy",
                                          value: {
                                            followCursor: true,
                                            placement: "bottom-end",
                                            theme: _vm.isDarkMode
                                              ? "light-border"
                                              : "google",
                                          },
                                          expression:
                                            "{\n                                    followCursor: true,\n                                    placement: 'bottom-end',\n                                    theme: isDarkMode ? 'light-border' : 'google',\n                                }",
                                        },
                                      ],
                                      staticClass: "md-icon-button",
                                      attrs: { content: "Connect To Instance" },
                                      on: {
                                        click: function () {
                                          return _vm.connect(item)
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "md-icon",
                                        { staticStyle: { color: "orange" } },
                                        [_vm._v("electrical_services")]
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "md-button",
                                    {
                                      directives: [
                                        {
                                          name: "b-modal",
                                          rawName: "v-b-modal.logModal",
                                          modifiers: { logModal: true },
                                        },
                                        {
                                          name: "tippy",
                                          rawName: "v-tippy",
                                          value: {
                                            followCursor: true,
                                            placement: "bottom-end",
                                            theme: _vm.isDarkMode
                                              ? "light-border"
                                              : "google",
                                          },
                                          expression:
                                            "{\n                                    followCursor: true,\n                                    placement: 'bottom-end',\n                                    theme: isDarkMode ? 'light-border' : 'google',\n                                }",
                                        },
                                      ],
                                      staticClass: "md-icon-button",
                                      attrs: {
                                        content: "Show Log Only Instance",
                                      },
                                      on: {
                                        click: function () {
                                          return _vm.showInstanceLog(item)
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "md-icon",
                                        { staticStyle: { color: "teal" } },
                                        [_vm._v("text_snippet")]
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "md-button",
                                    {
                                      directives: [
                                        {
                                          name: "tippy",
                                          rawName: "v-tippy",
                                          value: {
                                            followCursor: true,
                                            placement: "bottom-end",
                                            theme: _vm.isDarkMode
                                              ? "light-border"
                                              : "google",
                                          },
                                          expression:
                                            "{\n                                    followCursor: true,\n                                    placement: 'bottom-end',\n                                    theme: isDarkMode ? 'light-border' : 'google',\n                                }",
                                        },
                                      ],
                                      staticClass: "md-icon-button",
                                      attrs: { content: "Shutdown Server" },
                                      on: {
                                        click: function () {
                                          return _vm.shutdown(item)
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "md-icon",
                                        { staticStyle: { color: "red" } },
                                        [_vm._v("power_settings_new")]
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "md-button",
                                    {
                                      directives: [
                                        {
                                          name: "tippy",
                                          rawName: "v-tippy",
                                          value: {
                                            followCursor: true,
                                            placement: "bottom-end",
                                            theme: _vm.isDarkMode
                                              ? "light-border"
                                              : "google",
                                          },
                                          expression:
                                            "{\n                                    followCursor: true,\n                                    placement: 'bottom-end',\n                                    theme: isDarkMode ? 'light-border' : 'google',\n                                }",
                                        },
                                      ],
                                      staticClass: "md-icon-button",
                                      attrs: { content: "Restart Server" },
                                      on: {
                                        click: function () {
                                          return _vm.restart(item)
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "md-icon",
                                        { staticStyle: { color: "red" } },
                                        [_vm._v("restart_alt")]
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "md-button",
                                    {
                                      directives: [
                                        {
                                          name: "tippy",
                                          rawName: "v-tippy",
                                          value: {
                                            followCursor: true,
                                            placement: "bottom-end",
                                            theme: _vm.isDarkMode
                                              ? "light-border"
                                              : "google",
                                          },
                                          expression:
                                            "{\n                                    followCursor: true,\n                                    placement: 'bottom-end',\n                                    theme: isDarkMode ? 'light-border' : 'google',\n                                }",
                                        },
                                      ],
                                      staticClass: "md-icon-button",
                                      attrs: { content: "Start NetData" },
                                      on: {
                                        click: function () {
                                          return _vm.startNetdata(item)
                                        },
                                      },
                                    },
                                    [_c("md-icon", [_vm._v("sensors")])],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "md-button",
                                    {
                                      directives: [
                                        {
                                          name: "tippy",
                                          rawName: "v-tippy",
                                          value: {
                                            followCursor: true,
                                            placement: "bottom-end",
                                            theme: _vm.isDarkMode
                                              ? "light-border"
                                              : "google",
                                          },
                                          expression:
                                            "{\n                                    followCursor: true,\n                                    placement: 'bottom-end',\n                                    theme: isDarkMode ? 'light-border' : 'google',\n                                }",
                                        },
                                      ],
                                      staticClass: "md-icon-button",
                                      attrs: { content: "Stop NetData" },
                                      on: {
                                        click: function () {
                                          return _vm.stopNetdata(item)
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "md-icon",
                                        { staticStyle: { color: "red" } },
                                        [_vm._v("sensors")]
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  item.microService === "tablet"
                                    ? _c(
                                        "md-button",
                                        {
                                          directives: [
                                            {
                                              name: "tippy",
                                              rawName: "v-tippy",
                                              value: {
                                                followCursor: true,
                                                placement: "bottom-end",
                                                theme: _vm.isDarkMode
                                                  ? "light-border"
                                                  : "google",
                                              },
                                              expression:
                                                "{\n                                    followCursor: true,\n                                    placement: 'bottom-end',\n                                    theme: isDarkMode ? 'light-border' : 'google',\n                                }",
                                            },
                                          ],
                                          staticClass: "md-icon-button",
                                          attrs: { content: "Respawn Workers" },
                                          on: {
                                            click: function () {
                                              return _vm.respawnWorkers(item)
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "md-icon",
                                            {
                                              staticStyle: { color: "purple" },
                                            },
                                            [_vm._v("rocket_launch")]
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ]
                          )
                        },
                      },
                    ],
                    null,
                    true
                  ),
                }),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "b-modal",
            {
              attrs: {
                id: "monitorModal",
                centered: "",
                "hide-footer": "",
                "hide-header": "",
                "hide-header-close": "",
                size: "huge",
                title: "Node Monitoring",
              },
            },
            [
              _vm.netDataUrl
                ? _c("iframe", {
                    staticStyle: { width: "100%", height: "90vh" },
                    attrs: { src: _vm.netDataUrl },
                  })
                : _vm._e(),
            ]
          ),
          _vm._v(" "),
          _c(
            "b-modal",
            {
              attrs: {
                id: "logModal",
                centered: "",
                "hide-footer": "",
                "hide-header": "",
                "hide-header-close": "",
                size: "huge",
                title: "Log Viewer",
              },
            },
            [
              _vm.currentElasticSearchUrl
                ? _c("iframe", {
                    staticStyle: { width: "100%", height: "90vh" },
                    attrs: { src: _vm.currentElasticSearchUrl },
                  })
                : _vm._e(),
            ]
          ),
          _vm._v(" "),
          _c(
            "b-modal",
            {
              attrs: {
                id: "connectModal",
                centered: "",
                "hide-footer": "",
                size: "lg",
                title: "Connect To Instance",
              },
            },
            [
              _vm.connectStr
                ? _c("p", [_vm._v(_vm._s(_vm.connectStr))])
                : _vm._e(),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }